export default __webpack_public_path__ + "static/media/offermenuicon.9cb1e159.svg";